import React, { useState } from 'react';
import SubmitButton from './SubmitButton';
import AddressFields from './AddressFields';
import { Button, Divider, Field, Modal, TextInput } from './Ui';
import { bankAccountTypes, formateZodError } from '../../Utlils';
import { zodBankAccountSchema } from '../../pages/Validators';
import MultiSelectDropdown from '../MultiSelectDropdown';
import { useGlobalContext } from '../../Contexts/GlobalContext';



const AddBankAccountModal = ({
  showModal,
  setShowModal,
  handleCloseModal,
  modalData,
  setModalData,
  setCustomerData,
  edit = false,
  ediIndex,
  currentBankAccounts,
  onBankAccountsChange,
}) => {
  const { setNotice } = useGlobalContext();
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (name, value) => {
    setModalData((prev) => ({ ...prev, [name]: value }));
    if (formErrors[name]) {
      setFormErrors((prev) => ({ ...prev, [name]: undefined }));
    }
  };

  const handleNestedChange = (
    nest,
    name,
    value,
  ) => {
    setModalData((prev) => ({
      ...prev,
      [nest]: { ...prev[nest], [name]: value },
    }));
    if (formErrors[nest] && formErrors[nest][name]) {
      setFormErrors((prev) => ({
        ...prev,
        [nest]: { ...prev[nest], [name]: undefined },
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    try {
      e.preventDefault();
      const validationResult = zodBankAccountSchema.safeParse(modalData);
      if (!validationResult.success) {
        setFormErrors(formateZodError(validationResult.error.errors));
        return;
      }

      const validated = validationResult.data ;
      const buildBankAccounts = (existing) =>
        !edit
          ? [...existing, validated]
          : existing?.map((item, i) => (i === ediIndex ? validated : item));

      let nextBankAccounts = currentBankAccounts
        ? buildBankAccounts(currentBankAccounts)
        : [];

      setCustomerData((prev) => {
        const updated = currentBankAccounts
          ? nextBankAccounts
          : buildBankAccounts(prev?.bankAccounts || []);
        nextBankAccounts = updated;
        return { ...prev, bankAccounts: updated };
      });

      if (onBankAccountsChange) {
        await onBankAccountsChange(nextBankAccounts);
      }
      handleCloseModal();
    } catch (error) {
    //   showNotice(setNotice, 'Something went wrong', 'Unable to update bank account', 'error');
    }
  };

  const textField = (
    name,
    label,
    placeholder,
    required = false,
  ) => (
    <Field label={label} required={required} error={formErrors?.[name]}>
      <TextInput
        name={name}
        placeholder={placeholder}
        required={required && name === 'accountHolderName'}
        value={modalData?.[name] || ''}
        error={formErrors?.[name]}
        onChange={(e) => handleChange(name, e.target.value)}
      />
    </Field>
  );

  return (
    <Modal
      showModal={showModal}
      setShowModal={() => {
        handleCloseModal();
        setShowModal(!showModal);
      }}
      closeOnOutsideClick={false}
    >
      <form id="innerForm" className="space-y-[16px]" onSubmit={handleFormSubmit}>
        <h1 className="text-[18px] font-[600]">
          {edit ? 'Edit Bank Account' : 'Add Bank Account'}
        </h1>
        <Divider />

        <div className="containerScroll max-h-[450px] space-y-4 overflow-y-auto pr-2">
          <div className="grid grid-cols-2 items-start gap-3">
            {textField('accountHolderName', 'Account Holder Name', 'Enter Account Holder Name', true)}
            {textField('bankName', 'Bank Name', 'Enter Bank Name', true)}
          </div>

          <div className="grid grid-cols-2 items-start gap-3">
            {textField('accountNumber', 'Account Number', 'Enter Account Number', true)}
            {textField('ifscCode', 'IFSC Code', 'Enter IFSC Code')}
          </div>

          <div className="grid grid-cols-2 items-start gap-3">
            <Field label="Bank Type" required error={formErrors?.bankType}>
              <MultiSelectDropdown
                options={bankAccountTypes?.map((d) => ({
                  label: d,
                  value: d.toLowerCase(),
                }))}
                selected={[
                  {
                    label:
                      bankAccountTypes.find(
                        (d) => d.toLowerCase() === modalData.bankType,
                      ) || '',
                    value: modalData.bankType || '',
                  },
                ]}
                setSelected={(e) => {
                  const selected = e ;
                  handleChange('bankType', selected?.[0]?.value);
                }}
                dropdownText="Select Bank Type..."
              />
            </Field>
            {textField('ibanNumber', 'IBAN Number', 'Enter IBAN Number')}
          </div>

          <div className="grid grid-cols-2 items-start gap-3">
            {textField('swiftBic', 'Swift/BIC Code', 'Enter Swift/BIC Code')}
            {textField('nationalBankCode', 'National Bank Code', 'Enter National Bank Code')}
          </div>

          <div className="grid grid-cols-2 items-start gap-3">
            {textField('routingNumber', 'Routing Number', 'Enter Routing Number')}
          </div>

          <AddressFields
            addressKey="bankAddress"
            modalData={modalData}
            formErrors={formErrors}
            onNestedChange={handleNestedChange}
            cityDropdownPosition="top"
          />
        </div>

        <div className="flex w-full items-center justify-end gap-2">
          <Button
            variant="outlined"
            intent="default"
            type="button"
            onClick={handleCloseModal}
          >
            Close
          </Button>
          <SubmitButton size="sm" name="Save" />
        </div>
      </form>
    </Modal>
  );
};

export default AddBankAccountModal;